module.exports = __webpack_public_path__ + "img/QRberhasil.9769fbd4.svg";